import { lazyRetry } from "helpers/lazyRetry";

const Supervised_L = lazyRetry(() => import("./Supervised"));

export default Supervised_L;
